import { render, staticRenderFns } from "./detailsLotteryAct.vue?vue&type=template&id=6434b916&scoped=true&"
import script from "./detailsLotteryAct.vue?vue&type=script&lang=js&"
export * from "./detailsLotteryAct.vue?vue&type=script&lang=js&"
import style0 from "./detailsLotteryAct.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./detailsLotteryAct.vue?vue&type=style&index=1&id=6434b916&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6434b916",
  null
  
)

component.options.__file = "detailsLotteryAct.vue"
export default component.exports